import { useQuery } from '@tanstack/react-query';

import { TSegmentMention } from '@/features/segments/types';
import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';

import { TClipDeclaration, TClipLogo, TClipOcr, TClipPeople } from '../types';

type TPreviewClip = {
  clip_mentions: TSegmentMention[];
  clip_logos: TClipLogo[];
  clip_peoples: TClipPeople[];
  clip_ocrs: TClipOcr[];
  clip_declarations: TClipDeclaration[];
};

type TClipPreviewEnrichmentsFilters = {
  program_id?: string;
  start_datetime?: string;
  end_datetime?: string;
  shouldFetchPreview: boolean;
};
export async function getPreviewEnrichments(
  params?: TClipPreviewEnrichmentsFilters
): Promise<TPreviewClip> {
  return mediaManagerClient
    .get(`/api/v1/clips/preview_enrichments`, {
      params: {
        program_id: params?.program_id,
        start_datetime: params?.start_datetime,
        end_datetime: params?.end_datetime,
      },
    })
    .then(response => {
      return response as unknown as TPreviewClip;
    });
}

type QueryFnType = typeof getPreviewEnrichments;

interface UseSegmentIdParams {
  config?: QueryConfig<QueryFnType>;
  filters: TClipPreviewEnrichmentsFilters;
}

export function useGetPreviewEnrichments({ config, filters }: UseSegmentIdParams) {
  return useQuery({
    ...config,
    enabled: Boolean(
      filters?.program_id &&
        filters?.start_datetime &&
        filters?.end_datetime &&
        filters.shouldFetchPreview
    ),
    queryKey: ['preview_enrichments', filters],
    queryFn: () => getPreviewEnrichments(filters),
  });
}
